import { render } from "./ReviewUnitMalfunctionReports.vue?vue&type=template&id=7b201a14&scoped=true"
import script from "./ReviewUnitMalfunctionReports.vue?vue&type=script&lang=js"
export * from "./ReviewUnitMalfunctionReports.vue?vue&type=script&lang=js"

import "./ReviewUnitMalfunctionReports.vue?vue&type=style&index=0&id=7b201a14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b201a14"]])

export default __exports__